/* istanbul ignore file */
import { AwsRum, AwsRumConfig, Telemetry } from 'aws-rum-web';
import { RumMidwayCredentialsProvider } from '@amzn/rum-midway-credentials-provider';

export type RumClient = AwsRum | undefined;

const IGNORED_ERROR_PATTERNS = [/ResizeObserver loop/];

const isIgnorableRumError = (
  event: ErrorEvent | PromiseRejectionEvent,
): boolean => {
  const message = (event as ErrorEvent).message;
  if (typeof message !== 'string') return false;
  return IGNORED_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

const telemetries: Telemetry[] = [
  ['errors', { ignore: isIgnorableRumError }],
  'performance',
  'http',
];

const DOMAIN_BY_STAGE: Record<string, string> = {
  beta: 'https://beta.allocations.finergy.amazon.dev',
  gamma: 'https://gamma.allocations.finergy.amazon.dev',
  prod: 'https://allocations.finergy.amazon.dev',
};

export function getRumClient(stage: string): RumClient {
  try {
    const APPLICATION_ID = '5a9d6711-1e4d-4de5-9798-d19ea881bf64';
    const ROLE_ARN = 'arn:aws:iam::486366102267:role/midway-authentication-rum-gamma';

    // Skip initialization when placeholders are not replaced (local dev)
    if (!APPLICATION_ID || APPLICATION_ID.startsWith('{{')) return undefined;

    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
      telemetries,
      allowCookies: true,
      enableXRay: false,
    };

    const awsRum = new AwsRum(APPLICATION_ID, '1.0.0', 'us-west-2', config);

    const relyingParty = DOMAIN_BY_STAGE[stage] ?? DOMAIN_BY_STAGE.prod;
    const mwCredProvider = new RumMidwayCredentialsProvider(
      'us-west-2',
      relyingParty,
      ROLE_ARN,
    ).ChainAnonymousCredentialsProvider;

    awsRum.setAwsCredentials(mwCredProvider);
    return awsRum;
  } catch (error) {
    console.error('CloudWatch RUM initialization failed:', error);
  }
}
